import * as THREE from 'three'
import BirdGeometry from '@/geometries/BirdGeometry'

const WING_RANGE = 5
const LEFT_WING = 10
const RIGHT_WING = 19

export default class Bird extends THREE.Mesh {
  name = 'Bird'

  velocity = new THREE.Vector3()
  _phase = 0
  _size = 1

  constructor (color = 0xffffff) {
    const geometry = new BirdGeometry()
    const material = new THREE.MeshBasicMaterial({ color, side: THREE.DoubleSide })
    super(geometry, material)
  }

  get phase () {
    return this._phase
  }

  set phase (phase) {
    this._phase = phase % 62.83
    this._updateVertices()
  }

  get size () {
    return this._size
  }

  set size (size) {
    this._size = size
    this.scale.set(size, size, size)
  }

  _updateVertices () {
    const position = Math.sin(this._phase) * this._size * WING_RANGE
    this.geometry.attributes.position.array[LEFT_WING] = position
    this.geometry.attributes.position.array[RIGHT_WING] = position
    this.geometry.attributes.position.needsUpdate = true
  }
}
